import {
  CANCEL_COLOCATION,
  CANCEL_COLOCATION_IS_ERROR,
  CANCEL_COLOCATION_IS_PENDING,
  FETCH_ALERTS,
  FETCH_ALERTS_IS_ERROR,
  FETCH_ALERTS_IS_PENDING,
  FETCH_COLOCATION_BY_ID,
  FETCH_COLOCATION_BY_ID_IS_ERROR,
  FETCH_COLOCATION_BY_ID_IS_PENDING,
  FETCH_COLOCATION_IS_COMPLETE,
  FETCH_COLOCATION_IS_ERROR,
  FETCH_COLOCATION_IS_PENDING,
  FETCH_COLOCATION_PDU_BY_ID,
  FETCH_COLOCATION_PDU_BY_ID_IS_ERROR,
  FETCH_COLOCATION_PDU_BY_ID_IS_PENDING,
  FETCH_COLOCATION_UPLINK_BY_ID,
  FETCH_COLOCATION_UPLINK_BY_ID_IS_ERROR,
  FETCH_COLOCATION_UPLINK_BY_ID_IS_PENDING,
  FETCH_INVOICES,
  FETCH_INVOICES_IS_ERROR,
  FETCH_INVOICES_IS_PENDING,
  REVERT_CANCEL_COLOCATION,
  REVERT_CANCEL_COLOCATION_IS_ERROR,
  REVERT_CANCEL_COLOCATION_IS_PENDING,
  SET_RDNS,
  SET_RDNS_IS_ERROR,
  SET_RDNS_IS_PENDING,
  SORT,
  UPDATE_COLOCATION,
  UPDATE_COLOCATION_IS_ERROR,
  UPDATE_COLOCATION_IS_PENDING,
} from 'services/Colocation/types';
import { SortDirection } from 'types/common/sorting';
import { sort } from 'utils/functions';

const INITIAL_STATE = {
  colocations: [],
  colocation: [],
  colocationPDU: [],
  uplink: [],
  sortBy: 'id',
  sortDirection: 'ASC' as SortDirection,
  params: {
    type: 'function',
    sortSearchParam: 'id',
    sortSearchValue: (item: $TSFixMe) => item.id,
  },
  updateColocationIsCompleted: false,
  updateColocationIsPending: false,
  updateColocationIsError: null,
  IsCompleted: false,
  IsPending: false,
  IsError: null,
  fetchByIdIsCompleted: false,
  fetchByIdIsPending: false,
  fetchByIdIsError: null,
  fetchPDUByIdIsCompleted: false,
  fetchPDUByIdIsPending: false,
  fetchPDUByIdIsError: null,
  setRDNSIsCompleted: false,
  setRDNSIsPending: false,
  setRDNSIsError: null,
  cancelIsCompleted: false,
  cancelIsPending: false,
  cancelIsError: null,
  revertCancelIsCompleted: false,
  revertCancelIsPending: false,
  revertCancelIsError: null,
  fetchInvoicesIsCompleted: false,
  fetchInvoicesIsPending: false,
  fetchInvoicesIsError: null,
  alerts: [],
  fetchAlertsIsCompleted: false,
  fetchAlertsIsPending: false,
  fetchAlertsIsError: null,
  fetchUplinkIsCompleted: false,
  fetchUplinkIsPending: false,
  fetchUplinkIsError: null,
};

const colocationReducer = (
  state = {
    ...INITIAL_STATE,
  },
  action = undefined,
) => {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  switch (action.type) {
    case FETCH_COLOCATION_IS_COMPLETE: {
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        colocations: sort(action.data, {
          sortBy: state.sortBy,
          sortDirection: state.sortDirection,
          sortSearchValue: state.params.sortSearchValue || (state.params as $TSFixMe).value || null,
        }),
        IsCompleted: true,
        IsPending: false,
        IsError: null,
      };
    }

    case FETCH_COLOCATION_IS_PENDING: {
      return {
        ...state,
        IsCompleted: false,
        IsPending: true,
        IsError: null,
      };
    }

    case FETCH_COLOCATION_IS_ERROR: {
      return {
        ...state,
        IsCompleted: true,
        IsPending: false,
        IsError: true,
      };
    }

    case FETCH_COLOCATION_BY_ID:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        colocation: action.data,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,
        fetchByIdIsError: null,
      };
    case FETCH_COLOCATION_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchByIdIsCompleted: false,
        fetchByIdIsPending: true,
        fetchByIdIsError: null,
      };
    case FETCH_COLOCATION_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchByIdIsCompleted: true,
        fetchByIdIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchByIdIsError: action.error,
      };
    case FETCH_COLOCATION_PDU_BY_ID:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        colocationPDU: action.data,
        fetchPDUByIdIsCompleted: true,
        fetchPDUByIdIsPending: false,
        fetchPDUByIdIsError: null,
      };
    case FETCH_COLOCATION_PDU_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchPDUByIdIsCompleted: false,
        fetchPDUByIdIsPending: true,
        fetchPDUByIdIsError: null,
      };
    case FETCH_COLOCATION_PDU_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchPDUByIdIsCompleted: true,
        fetchPDUByIdIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchPDUByIdIsError: action.error,
      };
    case UPDATE_COLOCATION:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        colocation: action.data,
        updateColocationIsCompleted: true,
        updateColocationIsPending: false,
        updateColocationIsError: null,
      };
    case UPDATE_COLOCATION_IS_PENDING:
      return {
        ...state,
        updateColocationIsCompleted: false,
        updateColocationIsPending: true,
        updateColocationIsError: null,
      };
    case UPDATE_COLOCATION_IS_ERROR:
      return {
        ...state,
        updateColocationIsCompleted: true,
        updateColocationIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        updateColocationIsError: action.error,
      };
    case SET_RDNS:
      return {
        ...state,
        setRDNSIsCompleted: true,
        setRDNSIsPending: false,
        setRDNSIsError: null,
      };
    case SET_RDNS_IS_PENDING:
      return {
        ...state,
        setRDNSIsCompleted: false,
        setRDNSIsPending: true,
        setRDNSIsError: null,
      };
    case SET_RDNS_IS_ERROR:
      return {
        ...state,
        setRDNSIsCompleted: true,
        setRDNSIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        setRDNSIsError: action.error,
      };
    case CANCEL_COLOCATION:
      return {
        ...state,
        cancelIsCompleted: true,
        cancelIsPending: false,
        cancelIsError: null,
      };
    case CANCEL_COLOCATION_IS_PENDING:
      return {
        ...state,
        cancelIsCompleted: false,
        cancelIsPending: true,
        cancelIsError: null,
      };
    case CANCEL_COLOCATION_IS_ERROR:
      return {
        ...state,
        cancelIsCompleted: true,
        cancelIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        cancelIsError: action.error,
      };
    case REVERT_CANCEL_COLOCATION:
      return {
        ...state,
        revertCancelIsCompleted: true,
        revertCancelIsPending: false,
        revertCancelIsError: null,
      };
    case REVERT_CANCEL_COLOCATION_IS_PENDING:
      return {
        ...state,
        revertCancelIsCompleted: false,
        revertCancelIsPending: true,
        revertCancelIsError: null,
      };
    case REVERT_CANCEL_COLOCATION_IS_ERROR:
      return {
        ...state,
        revertCancelIsCompleted: false,
        revertCancelIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        revertCancelIsError: action.error,
      };
    case FETCH_INVOICES:
      return {
        ...state,
        fetchInvoicesIsCompleted: true,
        fetchInvoicesIsPending: false,
        fetchInvoicesIsError: null,
      };
    case FETCH_INVOICES_IS_PENDING:
      return {
        ...state,
        fetchInvoicesIsCompleted: false,
        fetchInvoicesIsPending: true,
        fetchInvoicesIsError: null,
      };
    case FETCH_INVOICES_IS_ERROR:
      return {
        ...state,
        fetchInvoicesIsCompleted: true,
        fetchInvoicesIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchInvoicesIsError: action.error,
      };
    case FETCH_ALERTS:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        alerts: action.data,
        fetchAlertsIsCompleted: true,
        fetchAlertsIsPending: false,
        fetchAlertsIsError: null,
      };
    case FETCH_ALERTS_IS_PENDING:
      return {
        ...state,
        fetchAlertsIsCompleted: false,
        fetchAlertsIsPending: true,
        fetchAlertsIsError: null,
      };
    case FETCH_ALERTS_IS_ERROR:
      return {
        ...state,
        fetchAlertsIsCompleted: true,
        fetchAlertsIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchAlertsIsError: action.error,
      };
    case SORT:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        sortBy: action.params.sortSearchParam,
        sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        params: action.params,
        colocations: sort(state.colocations, {
          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortBy: action.params.sortSearchParam,
          sortDirection: state.sortDirection === 'ASC' ? 'DESC' : 'ASC',

          // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
          sortSearchValue: action.params.sortSearchValue || action.params.value,
        }),
      };

    case FETCH_COLOCATION_UPLINK_BY_ID:
      return {
        ...state,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        uplink: action.data,
        fetchUplinkIsCompleted: true,
        fetchUplinkIsPending: false,
        fetchUplinkIsError: null,
      };
    case FETCH_COLOCATION_UPLINK_BY_ID_IS_PENDING:
      return {
        ...state,
        fetchUplinkIsCompleted: false,
        fetchUplinkIsPending: true,
        fetchUplinkIsError: null,
      };
    case FETCH_COLOCATION_UPLINK_BY_ID_IS_ERROR:
      return {
        ...state,
        fetchUplinkIsCompleted: true,
        fetchUplinkIsPending: false,

        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        fetchUplinkIsError: action.error,
      };

    case 'RESET_COLOCATION_REDUCER':
    case 'RESET_REDUCER':
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default colocationReducer;
